import type { UploadableFile } from '@/composables/use-file-uploads/types/models/UploadableFile.ts'
import type { MeasurementUnitModel } from '@/domains/measurement-units/types/models/MeasurementUnitModel.ts'
import type { CostPriceModel } from '@/domains/products/types/models/CostPriceModel.types.ts'
import type { InventoryItemRequestModel } from '@/domains/products/types/models/InventoryItemModel.types.ts'
import type { SkuCodeModel } from '@/domains/products/types/models/SkuCodeModel.types.ts'
import type { VariantOptionModel } from '@/domains/variants/types/models/VariantOptionModel.types.ts'

import { PricingTypeEnum } from '@/domains/products/types/consts/PricingTypeEnum.ts'

interface VariantModel {
  accounting_group_id?: string | null
  allow_out_of_stock: boolean
  compare_at: number | null
  cost_per_item?: number | null
  cost_prices: CostPriceModel[]
  currency?: string
  downloadable_media_ids?: number[]
  fee_ids?: number[]
  id?: number
  inventory_items?: InventoryItemRequestModel[]
  is_published: boolean
  measurement_unit_id: number | null
  measurement_value: number | null
  media: UploadableFile[]
  price?: number | null
  pricing_type: PricingTypeEnum
  pricing_unit: MeasurementUnitModel | null
  profit_margin: string | null
  sku_codes: SkuCodeModel[]
  track_inventory: boolean
  type?: string
  unit_id: number | null
  variant_type_options: VariantOptionModel[]
  vat_rate_id?: number | null
  vat_rate: number | null
  available_sales_channels: string[] | null
  suppliers: string[] | null
  last_sold_date?: string | null
}

interface TempVariantModel extends VariantModel {
  _tempId: string
}

const DEFAULT_VARIANT = (): VariantModel => ({
  accounting_group_id: null,
  allow_out_of_stock: false,
  compare_at: null,
  cost_prices: [],
  downloadable_media_ids: [],
  fee_ids: [],
  is_published: false,
  measurement_unit_id: null,
  measurement_value: null,
  media: [],
  price: 0,
  pricing_type: PricingTypeEnum.static,
  pricing_unit: null,
  profit_margin: '0',
  sku_codes: [],
  track_inventory: true,
  unit_id: null,
  variant_type_options: [],
  vat_rate_id: null,
  vat_rate: null,
  available_sales_channels: [],
  suppliers: []
})

export { DEFAULT_VARIANT }
export type { VariantModel, TempVariantModel }
